import React, { useEffect } from "react";
import deliverBoy from "./../../../assets/icons/delivery-boy.png";
import payments from "./../../../assets/icons/payment-method.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import pendingImg from "./../../../assets/icons/pending.png";
import NavbarCourier from "../components/NavbarCourier";

const CourierDashboard = () => {
  const navigate = useNavigate();
  const apiAddress = process.env.REACT_APP_SECRET;
  const [ispending, setIsPending] = useState(false);

  useEffect(() => {
    var decoded = {};
    const token = localStorage.getItem("gotasteadmintoken");

    if (token != null) {
      try {
        decoded = jwtDecode(token);
        console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }

    axios
      .get(
        apiAddress +
          "/api/Courier/getcouriermasterdetailsbyid?id=" +
          decoded.courierId
      )
      .then((response) => {
        console.log(response.data.approvalStatusDescription);
        if (response.data.approvalStatusDescription === "Pending") {
          setIsPending(true);
        }
      });
  }, []);

  return (
    <div>
      <NavbarCourier />
      <div className="row">
        <div className="col-2"></div>
        <div className="col-8 mt-3">
          <h2>Getting started</h2>
        </div>
        <div className="col-2"></div>
      </div>

      {ispending ? (
        <div
          className="d-flex justify-content-center align-items-center "
          style={{ flexDirection: "column", height: "100vh" }}
        >
          <div>
            <img src={pendingImg} alt="" style={{ width: "5rem" }} />
          </div>
          <p>Please wait for admin approval</p>
        </div>
      ) : (
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4 col-xl-3">
            <div
              className="wrimagecard wrimagecard-topimage"
              onClick={() => {
                navigate("/pending-orders");
              }}
            >
              <div className="wrimagecard-topimage_header">
                <img src={deliverBoy} alt="" className="img-circle" />
              </div>
              <div className="wrimagecard-topimage_title h-140">
                <h2
                  style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}
                >
                  Orders
                </h2>
                <p>Manage Preparing orders and more</p>
              </div>

              <div className="card-action-bar">
                <a className="float-lg-none link" href="#">
                  View Orders
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 col-xl-3">
            <div
              className="wrimagecard wrimagecard-topimage"
              onClick={() => {
                navigate("/restaurant-request");
              }}
            >
              <div className="wrimagecard-topimage_header">
                <img src={payments} alt="" className="img-circle" />
              </div>
              <div className="wrimagecard-topimage_title h-140">
                <h2
                  style={{ fontWeight: "100 !important", fontSize: "1.5rem" }}
                >
                  Payment Details
                </h2>
                <p>Manage Payment and more</p>
              </div>
              {/* <div className='rounded-CircleIcon'>
                            1
                        </div> */}
              <div className="card-action-bar">
                <a className="float-lg-none link">View Details</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourierDashboard;
